export default __webpack_public_path__ + "static/media/b2.b883c71b.jpeg";